<div class="resize-bar" (mousedown)="setStatus($event, 1)" (window:mouseup)="setStatus($event, 0)">
  <div class="resize-icon"></div>
</div>